import { ComponentNamesForPermission, LevelName } from 'src/utils/enums';

export const permissionsConfig: Record<ComponentNamesForPermission, LevelName> = {
    [ComponentNamesForPermission.AdvancedThreatProtection]: LevelName.GOLD,
    [ComponentNamesForPermission.AppProtection]: LevelName.SILVER
};

export const levelNameToValue: Record<LevelName, number> = {
    [LevelName.GOLD]: 3,
    [LevelName.SILVER]: 2,
    [LevelName.BRONZE]: 1,
};